import { SensitivityLevel } from '@ariksa/data-scanning';
import {
  DataClassifiers,
  DataExclusionsApiAddDataExclusionRequest,
  DataExclusionsApiDeleteDataExclusionRequest,
  DataExclusionsApiUpdateDataExclusionRequest,
  DataTypesApiAddDataTypeRequest,
  DataTypesApiDeleteDataTypeRequest,
  DataTypesApiUpdateDataTypeRequest,
} from '@ariksa/data-scanning/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { DataScanningService } from 'api/services';

import { actions } from './slice';

export function* dataClassificationSaga() {
  yield takeLatestAction(actions.getDataTypes, doGetDataTypes);
  yield takeLatestAction(actions.addDataType, doCreateDataType);
  yield takeLatestAction(actions.updateDataType, doUpdateDataType);
  yield takeLatestAction(actions.deleteDataType, doDeleteDataType);
  yield takeLatestAction(actions.getSensitivityInfo, doGetSensitivityInfo);

  yield takeLatestAction(actions.getDataExclusions, doGetDataExclusions);
  yield takeLatestAction(actions.addDataExclusion, doCreateDataExclusion);
  yield takeLatestAction(actions.updateDataExclusion, doUpdateDataExclusion);
  yield takeLatestAction(actions.deleteDataExclusion, doDeleteDataExclusion);
}

//data exclusion
export function* doGetDataExclusions(ctx: QueryContext<DataClassifiers[]>) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataExclusions.getDataExclusions(ctx.params),
    { errorMsg: 'Failed to get data exclusions!' },
  );
}

export function* doCreateDataExclusion(
  ctx: QueryContext<any, DataExclusionsApiAddDataExclusionRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataExclusions.addDataExclusion(ctx.params),
    { errorMsg: 'Failed to create data exclusion!' },
  );
}

export function* doDeleteDataExclusion(
  ctx: QueryContext<any, DataExclusionsApiDeleteDataExclusionRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataExclusions.deleteDataExclusion(ctx.params),
    { errorMsg: 'Failed to delete data exclusion!' },
  );
}

export function* doUpdateDataExclusion(
  ctx: QueryContext<any, DataExclusionsApiUpdateDataExclusionRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataExclusions.updateDataExclusion(ctx.params),
    { errorMsg: 'Failed to update data exclusion!' },
  );
}

// data types
export function* doGetDataTypes(ctx: QueryContext<DataClassifiers[]>) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataTypes.getDataTypes(ctx.params),
    { errorMsg: 'Failed to get data types!' },
  );
}

export function* doCreateDataType(
  ctx: QueryContext<any, DataTypesApiAddDataTypeRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataTypes.addDataType(ctx.params),
    { errorMsg: 'Failed to create data type!' },
  );
}

export function* doDeleteDataType(
  ctx: QueryContext<any, DataTypesApiDeleteDataTypeRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataTypes.deleteDataType(ctx.params),
    { errorMsg: 'Failed to delete data type!' },
  );
}

export function* doUpdateDataType(
  ctx: QueryContext<any, DataTypesApiUpdateDataTypeRequest>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataTypes.updateDataType(ctx.params),
    { errorMsg: 'Failed to update data type!' },
  );
}

export function* doGetSensitivityInfo(
  ctx: QueryContext<Record<string, SensitivityLevel>>,
) {
  yield call(
    ctx.fetch,
    () => DataScanningService.DataTypes.getDataTypesCategories(ctx.params),
    { errorMsg: 'Failed to get sensitive categories!' },
  );
}
